import { Component, inject } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CustomValidators } from "../custom-validators";
import { IMMEDIATE_ERROR_STATE_MATCHER } from "../immediate-error-state-matcher";
import { TimerService } from "../services/timer.service";

interface IEditAlarmForm {
  alarmDuration: FormControl<string>;
}

@Component({
    selector: "nx-edit-alarm-dialog",
    templateUrl: "./edit-alarm-dialog.component.html",
    styleUrls: ["./edit-alarm-dialog.component.scss"],
    standalone: false
})
export class EditAlarmDialogComponent {
  data = inject(MAT_DIALOG_DATA);
  formBuilder = inject(FormBuilder);
  timerService = inject(TimerService);
  dialogRef = inject<MatDialogRef<EditAlarmDialogComponent>>(MatDialogRef);

  public editAlarmForm: FormGroup<IEditAlarmForm>;
  public immediateMatcher = IMMEDIATE_ERROR_STATE_MATCHER;

  constructor() {
    this.editAlarmForm = this.formBuilder.nonNullable.group(
      {
        "alarmDuration": [
          "",
          [Validators.required, CustomValidators.validateDuration],
        ],
      },
    );
  }

  public setAlarm(duration: string) {
    this.timerService.setAlarm(duration, this.data["timer"]);

    this.dialogRef.close();
  }
}
